const Plural = () =>{
    return(
        <>
            <h6>Множественное число в английском языке</h6>
            <p>
            В английском языке, как и в русском, все слова делятся на исчисляемые и неисчисляемые. Это важно понимать при образовании множественного числа того или иного слова. Исчисляемые существительные обозначают те предметы, которые можно посчитать, например: table (стол), book (книга), apple (яблоко). Неисчисляемые существительные — это абстрактные понятия, жидкости, продукты и т. д., то есть то, что нельзя посчитать. Например: знания (knowledge), вода (water), мясо (meat), мука (flour). У этих слов нет множественного или единственного числа.
            <br/><br/>
            Исчисляемые существительные могут употребляться в единственном и множественном числе. Существительное в единственном числе обозначает один предмет, это та форма слова, которая указывается в словаре: apple — яблоко. Существительное во множественном числе обозначает несколько предметов: apples — яблоки.
            <br/><br/>
            Как образуется множественное число существительных:
            <br/><br/>
            Обычно множественное число имен существительных образуется путем добавления к слову окончания -s: book – books (книга – книги). Однако есть несколько особенностей правописания:
            </p>
            <ul>
                <li>
                    Если слово заканчивается на -o, -s, -ss, -sh, -ch, -x, то добавляем окончание -es: hero – heroes (герой – герои), bus – buses (автобус – автобусы).
                    <br/><br/>
                    <span>Исключения:</span> photo – photos (фотография – фотографии), video – videos (видеозапись – видеозаписи), radio – radios (радио – несколько радио), rhino – rhinos (носорог – носороги), piano – pianos (фортепиано – несколько фортепиано), hippo – hippos (бегемот – бегемоты).
                </li>
                <li>
                    Если слово заканчивается на -f, -fe, то меняем окончание на -ves: knife – knives (нож – ножи), leaf – leaves (лист – листья), wife – wives (жена – жены).
                    <br/><br/>
                    <span>Исключения:</span> roof – roofs (крыша – крыши), giraffe – giraffes (жираф – жирафы), cliff – cliffs (утес – утесы).
                </li>
                <li>Если слово заканчивается на -y, перед которой стоит согласная буква, то -y мы меняем на -ies: body – bodies (тело – тела).</li>
                <li>Если слово заканчивается на -y, перед которой стоит гласная, то добавляем окончание -s: boy – boys (мальчик – мальчики).</li>
            </ul>
            <p>
                В английском языке есть и слова-исключения, которые образуют множественное число не по правилам. Такие слова надо просто выучить наизусть, к счастью, их не очень много.
            </p>
            <table className="max-w-[1000px] mx-auto">
                <th className=" bg-yellow-300 border-2 w-[300px] py-[20px]">Единственное число     
                </th>
                <th className=" bg-yellow-400 border-2 w-[300px]">Множественное число 
                </th>
                <tbody className="bg-white">
                    <tr> 
                        <td className="pl-[20px] border-2 py-[10px] font-serif">man — мужчина</td>
                        <td className="pl-[20px] border-2 py-[10px] font-serif">men — мужчины</td>
                    </tr>
                    <tr> 
                        <td className="pl-[20px] border-2 py-[10px] font-serif">woman — женщина</td>
                        <td className="pl-[20px] border-2 py-[10px] font-serif">women — женщины</td>
                    </tr>
                    <tr> 
                        <td className="pl-[20px] border-2 py-[10px] font-serif">child — ребенок</td>
                        <td className="pl-[20px] border-2 py-[10px] font-serif">children — дети</td>
                    </tr>
                    <tr> 
                        <td className="pl-[20px] border-2 py-[10px] font-serif">person — человек</td>
                        <td className="pl-[20px] border-2 py-[10px] font-serif">people — люди</td>
                    </tr>
                    <tr> 
                        <td className="pl-[20px] border-2 py-[10px] font-serif">foot — ступня</td>
                        <td className="pl-[20px] border-2 py-[10px] font-serif">feet — ступни</td>
                    </tr>
                    <tr> 
                        <td className="pl-[20px] border-2 py-[10px] font-serif">mouse — мышь</td>
                        <td className="pl-[20px] border-2 py-[10px] font-serif">mice — мыши</td>
                    </tr>
                    <tr> 
                        <td className="pl-[20px] border-2 py-[10px] font-serif">tooth — зуб</td>
                        <td className="pl-[20px] border-2 py-[10px] font-serif">teeth — зубы</td>
                    </tr>
                    <tr> 
                        <td className="pl-[20px] border-2 py-[10px] font-serif">sheep — овца</td>
                        <td className="pl-[20px] border-2 py-[10px] font-serif">sheep — овцы</td>
                    </tr>

                </tbody>
            </table>
        </>
    )
}
export default Plural;